import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {Router} from '@angular/router';
import {PageContentService} from "@app/services/help/pagecontent.service";
import {PageContent} from '@app/models/help/pagecontent.model';
import {FunctionService} from "@app/services/functioninfo/function.service";
import {FunctionModel} from "@app/models/functioninfo/function.model";
import {Section} from "@app/models/help/section.model";
import {SectionService} from "@app/services/help/section.service";
import {ToastrService} from "ngx-toastr";
import { Environment } from '@env/environment.global';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  public keyword: string= '';
  public pageContents: PageContent[];
  public sectionId?: number = null;
  public url: string;
  public functions: FunctionModel[];
  public selectedFunctionId: number = null;
  public sections: Section[];

  constructor(private activatedRoute: ActivatedRoute,
              private pageContentService: PageContentService,
              private toasterService: ToastrService,
              private functionService: FunctionService,
              private sectionService: SectionService,
              private router: Router,
              private environment: Environment) {
    this.url = this.environment.getBaseUrl();
  }

  public ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.keyword = params['keyword'];
      if (this.keyword) {
        this.search();
      } else {
        this.keyword = '';
      }
    });
    this.functionService.getFunctionsForComboAvailableToUser().subscribe(result => {
      this.functions = result.sort((a, b) => {
        if (a.name > b.name) {
          return 1;
        }
        return -1;
      });
    });

    this.sectionService.getList().subscribe((result => {
      this.sections = result;
    }))
  }

  public search() {
    this.pageContentService.search(this.sectionId, this.keyword, this.selectedFunctionId).subscribe(result => {
      this.pageContents = <PageContent[]>result;
      if (this.pageContents.length === 0)
        this.toasterService.warning('Please try another keyword.', 'No results');
    });
  }

  public navigateToPageContentDetail(id) {
    this.router.navigateByUrl('/help/pagecontent?id=' + id);
  }
}
